import React, { Fragment } from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { Link } from "react-router-dom"
import { compose } from "redux"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { get, isEmpty } from "lodash"
import SelectHR from "components/Select"

import {
  makeSelectTeams,
  makeSelectDivisions,
  makeSelectDivisionsAvailable,
  makeSelectIsLoadingMultipleChoiceQuestions,
  makeSelectMultipleChoiceQuestions,
  makeSelectIsLoadingDivisions,
  makeSelectIsLoadingTeams,
  makeSelectReportMeasureInfo,
} from "containers/Report/Home/selectors"

import { makeSelectCurrentMedition } from "containers/Report/Header/selectors"

import PropTypes from "prop-types"

import {
  getStatusWatcher,
  getMultipleWatcher,
  getDivisionsWatcher,
  getMultipleChoiceQuestionWatcher,
  getTeamsWatcher,
} from "containers/Report/Home/actions"
import reducer from "containers/Report/Home/reducer"
import saga from "containers/Report/Home/saga"

import Layout from "components/Layout"
import { Select, Spin, Input, Popover, Empty } from "antd"
import ReportHeader from "containers/Report/Header"
import empty_meditions from "images/emptyQuestionsReports.svg"
import "./index.less"
import { LeftOutlined } from "@ant-design/icons"
import HorizontalBarMultipleAnswer from "../../../Reports/components/ReChart/HorizontalBarMultipleAnswer"
import PieChartSingleAnswer from "../../../Reports/components/ReChart/PieChartSingleAnswer"
import LegendPieChart from "../../../Reports/components/LegendPieChart"
import { validate } from "../../../utils/functions"
import { loadTexts } from "../../../utils/i18n"

const { Option } = Select

export class MultipleChoiceQuestion extends React.Component {
  intlMultipleChoice = loadTexts("reports_multiple_choice_view")
  state = {
    measure_id: this.props.match.params.id,
    // questionSelected: null,
    divisionSelected: null,
    // totalAnswers: undefined,
    // textFilter: "",
  }

  componentDidMount = () => {
    const { location, current_medition, measureInfo } = this.props
    const searchLocation = getUrlParams(location.search)
    const type_survey = get(measureInfo, "id_survey_type", 1)

    if (searchLocation) {
      this.setState({
        divisionSelected: Number(searchLocation.id_division),
      })
    }

    let paramPath = { ...searchLocation }

    this.getData()

    this.props.getMultipleQuestions({
      isHome: true,
      measure: this.state.measure_id,
      history: this.props.history,
      params: {
        id_division:
          isEmpty(paramPath.id_divisionParent) ||
          paramPath.id_divisionParent === undefined ||
          paramPath.id_divisionParent === "undefined"
            ? null
            : paramPath.id_divisionParent,
        id_divisionParent:
          isEmpty(paramPath.id_divisionParent) ||
          paramPath.id_divisionParent === undefined ||
          paramPath.id_divisionParent === "undefined"
            ? null
            : paramPath.id_divisionParent,
        id_segment: validate.empty(paramPath.id_segment)
          ? ""
          : paramPath.id_segment,
        id_survey_type: type_survey,
      },
      id_segment: validate.empty(paramPath.id_segment)
        ? ""
        : paramPath.id_segment,
    })
  }

  getData = async () => {
    const { current_medition, measureInfo } = this.props
    const type_survey = get(measureInfo, "id_survey_type", 1)

    const searchLocation = getUrlParams(location.search)
    let paramsPath = { ...searchLocation }

    const id_divisionParent =
      isEmpty(paramsPath.id_divisionParent) ||
      paramsPath.id_divisionParent === undefined ||
      paramsPath.id_divisionParent === "undefined"
        ? ""
        : `&id_divisionParent=${paramsPath.id_divisionParent}`

    const params = {
      id_measure: this.state.measure_id,
      measure: this.state.measure_id,
      id_survey_type: type_survey,
      params: {
        id_measure: this.state.measure_id,
        division: this.state.divisionSelected || id_divisionParent,
        id_segment: validate.empty(paramsPath.id_segment)
          ? ""
          : paramsPath.id_segment,
      },
      id_segment: validate.empty(paramsPath.id_segment)
        ? ""
        : paramsPath.id_segment,
    }

    this.props.getMultipleChoiceQuestions(params)

    if (type_survey === 2) {
      const paramsTeams = {
        measure: this.state.measure_id,
        params: {
          measure: this.state.measure_id,
          id_segment: validate.empty(paramsPath.id_segment)
            ? ""
            : paramsPath.id_segment,
        },
        id_segment: validate.empty(paramsPath.id_segment)
          ? ""
          : paramsPath.id_segment,
      }
      this.props.getTeams(paramsTeams)
    }
  }

  searchFilter = () => {}

  renderFilter = () => {
    const { divisionSelected } = this.state
    const {
      current_medition,
      teams,
      divisions_available,
      measureInfo,
    } = this.props
    const type_survey = get(measureInfo, "id_survey_type", 1)

    const searchLocation = getUrlParams(location.search)
    let paramsPath = { ...searchLocation }

    const id_divisionParent =
      isEmpty(paramsPath.id_divisionParent) ||
      paramsPath.id_divisionParent === undefined ||
      paramsPath.id_divisionParent === "undefined"
        ? ""
        : `&id_divisionParent=${paramsPath.id_divisionParent}`

    const idSegment = validate.empty(paramsPath.id_segment)
      ? ""
      : `&id_segment=${paramsPath.id_segment}`

    if (type_survey === 2) {
      return (
        <SelectHR
          allowClear
          value={divisionSelected || undefined}
          options={teams.filter((obj, pos, arr) => {
            return (
              arr
                .map((mapObj) => mapObj.id_position)
                .indexOf(obj.id_position) === pos
            )
          })}
          placeholder={this.intlMultipleChoice.selectLeaderPlaceHolder}
          style={{ width: 200 }}
          label="name"
          labelKey="id_employee"
          onChange={(s) => {
            s = s ? parseInt(s.id_position) : null
            this.setState({ divisionSelected: s }, () => this.getData())
          }}
        />
      )
    }

    return (
      <SelectHR
        allowClear={!validRole({ role: [5] })}
        value={divisionSelected || undefined}
        options={divisions_available}
        placeholder={this.intlMultipleChoice.selectDivisionPlaceHolder}
        style={{ width: 200 }}
        label="name"
        labelKey="id_division"
        onChange={(s) => {
          s = s ? parseInt(s.id_division) : null
          if (s) {
            this.props.history.push(
              `${this.props.history.location.pathname}?id_division=${s}${id_divisionParent}${idSegment}`
            )
          } else {
            this.props.history.push(
              `${this.props.history.location.pathname}?f${idSegment}`
            )
          }
          this.setState({ divisionSelected: s }, () => this.getData())
          this.getData()
        }}
      />
    )
  }

  renderButtonBack = () => {
    const { current_meditio, measureInfo } = this.props
    const type_survey = get(measureInfo, "id_survey_type", 1)
    const measureId = this.props.match.params.id
    const params = this.props.location.search

    // Function to return to medition o report home
    let link = `/reports/measure/${type_survey}/${measureId}${params}`
    if (this.props.isMeasure) {
      link = `/models/measure/${measureId}`
    }
    return (
      <div className="ReportsDimensionByDivision-header-btn-back">
        <span style={{ fontSize: "13px" }}>
          <Link to={link}>
            <LeftOutlined />{" "}
            {this.props.isMeasure
              ? "Medición"
              : this.intlMultipleChoice.backLink}
          </Link>
        </span>
      </div>
    )
  }

  renderChartMultipleAnswer = (options) => {
    return (
      <div className="WidgetMultipleChoiceQuestions__Content__BarChart">
        <HorizontalBarMultipleAnswer data={options} />
      </div>
    )
  }

  renderChartSingleAnswer = (options) => {
    return (
      <div className="WidgetMultipleChoiceQuestions__Content__PieChart">
        <div className="WidgetMultipleChoiceQuestions__Content__PieChart--aux">
          <PieChartSingleAnswer data={options} />
          <LegendPieChart data={options} />
        </div>
      </div>
    )
  }

  renderContent = () => {
    const { multipleChoiceQuestions } = this.props
    let cards = []
    multipleChoiceQuestions.forEach((obj) => {
      cards.push(
        <div className="WidgetMultipleChoiceQuestions">
          <div className="WidgetMultipleChoiceQuestions__Content">
            <div className="WidgetMultipleChoiceQuestions__Content__Header">
              <strong>{obj.question_name}</strong>
              <div className="WidgetMultipleChoiceQuestions__Content__Header--info">
                <span>
                  <strong>{this.intlMultipleChoice.answerType}</strong>:{" "}
                  {obj && obj.multiple_responses
                    ? this.intlMultipleChoice.multipleChoice
                    : this.intlMultipleChoice.single}
                </span>{" "}
                |{" "}
                <span>
                  <strong>{this.intlMultipleChoice.answers}</strong>:{" "}
                  {obj && obj.options
                    ? obj.options
                        .map((item) => item.employees)
                        .reduce(
                          (previousValue, currentValue) =>
                            previousValue + currentValue,
                          0
                        )
                    : 0}
                </span>
              </div>
            </div>
            <div className="WidgetMultipleChoiceQuestions__Content__Chart">
              {obj && obj.multiple_responses
                ? this.renderChartMultipleAnswer(obj.options)
                : this.renderChartSingleAnswer(obj.options)}
            </div>
          </div>
        </div>
      )
    })

    return <>{cards}</>
  }

  render = () => {
    const { divisionSelected, measure_id } = this.state
    const {
      history,
      match,
      divisions,
      teams,
      current_medition,
      measureInfo,
      isLoadingMultipleChoiceQuestions,
      isLoadingDivisions,
    } = this.props

    const isLoadingScreen =
      isLoadingMultipleChoiceQuestions || isLoadingDivisions

    const type_survey = get(measureInfo, "id_survey_type", 1)
    let divisionSelectedInfo
    if (type_survey === 2) {
      divisionSelectedInfo = teams.find(
        (d) => d.id_position === divisionSelected
      )
    } else {
      divisionSelectedInfo = divisions.find(
        (d) => d.id_division === divisionSelected
      )
    }

    let anonymityValidate = measureInfo.anonymity_check
    if (divisionSelectedInfo) {
      anonymityValidate = divisionSelectedInfo.anonymity_check.valid
    }

    // const isWordCloudModule = isModuleBySlug(WORD_CLOUD)
    return (
      <Layout>
        <Helmet>
          <title>{this.intlMultipleChoice.titlePage}</title>
        </Helmet>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: 0,
          }}>
          <div
            style={{ position: "relative" }}
            className="ReportsQualitativeQuestion">
            <div className="ReportsQualitativeQuestion-header">
              {this.renderButtonBack()}
            </div>
            <div className="ReportsQualitativeQuestion-header">
              <h4>{this.intlMultipleChoice.title}</h4>
              <div
                style={{
                  display: "grid",
                  gap: "1rem",
                }}>
                {this.renderFilter()}
              </div>
            </div>
            {isLoadingScreen ? (
              <div className="loadingSpin">
                <Spin size="large" />
              </div>
            ) : anonymityValidate ? (
              this.renderContent()
            ) : (
              <Empty
                style={{ color: "#828282" }}
                image={empty_meditions}
                description={
                  <span
                    style={{
                      margin: "0 auto",
                      maxWidth: 440,
                      display: "block",
                    }}>
                    ¡Aún no se cuenta con un resultado!
                  </span>
                }
                className="ReportsHome-empty-fix"
              />
            )}
          </div>
        </div>
      </Layout>
    )
  }
}

MultipleChoiceQuestion.propTypes = {
  getMultipleChoiceQuestions: PropTypes.func,
}

const mapStateToProps = createStructuredSelector({
  divisions: makeSelectDivisions(),
  divisions_available: makeSelectDivisionsAvailable(),
  teams: makeSelectTeams(),
  isLoadingTeams: makeSelectIsLoadingTeams(),
  isLoadingDivisions: makeSelectIsLoadingDivisions(),
  measureInfo: makeSelectReportMeasureInfo(),

  current_medition: makeSelectCurrentMedition(),

  isLoadingMultipleChoiceQuestions: makeSelectIsLoadingMultipleChoiceQuestions(),
  multipleChoiceQuestions: makeSelectMultipleChoiceQuestions(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDivisions: (params) => dispatch(getDivisionsWatcher(params)),
    getTeams: (params) => dispatch(getTeamsWatcher(params)),
    getListQuestions: (params) => dispatch(getListQuestionsWatcher(params)),
    getStatus: (params) => dispatch(getStatusWatcher(params)),
    getMultipleChoiceQuestions: (params) =>
      dispatch(getMultipleWatcher(params)),
    getMultipleQuestions: (params) =>
      dispatch(getMultipleChoiceQuestionWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "reportHome", reducer })
const withSaga = injectSaga({ key: "reportHome", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(MultipleChoiceQuestion)
